import { Box, Card, HR } from '@betterment/style-closet-react';

import InvitationListItem from './InvitationListItem';
import { useReferralSenderOffer } from './ReferAFriendProvider';

import { Referral } from '../data';

type GroupRefferalbyStatus = {
  signedUp: Referral[];
  completed: Referral[];
  invited: Referral[];
};

type KeysOfUserReferredStates = keyof GroupRefferalbyStatus;
const groupRefferalbyStatus = (referralInvites: Referral[] | null) => {
  const result: GroupRefferalbyStatus = {
    completed: [],
    signedUp: [],
    invited: [],
  };

  if (!referralInvites) return result;
  referralInvites.forEach(item => {
    switch (item.status) {
      case 'funded':
        result.completed.push(item);
        return;
      case 'signed_up':
        result.signedUp.push(item);
        return;
      case 'prompt':
      case 'sent':
        result.invited.push(item);
    }
  });
  return result;
};

const InvitationListCard: React.FC = () => {
  const { referralInvites } = useReferralSenderOffer();
  const referrals = groupRefferalbyStatus(referralInvites);
  const referralStatues = Object.keys(referrals) as KeysOfUserReferredStates[];
  if (referralInvites.length === 0) return null;

  return (
    <Card>
      <Card.Slot name="header">Your referred friends</Card.Slot>
      <Card.Slot name="body">
        {referralStatues.map((referralState, index) => {
          const referralData = referrals[referralState];

          if (referralData.length === 0) return null;
          const isLastItemInList = referralStatues.length === (index += 1);
          const rowTitle = referralState
            .split(/(?=[A-Z])/)
            .join(' ')
            .toUpperCase();

          return (
            <Box key={referralState}>
              <InvitationListItem title={rowTitle} referralData={referralData} />
              {!isLastItemInList && <HR mt="8" pb="8" />}
            </Box>
          );
        })}
      </Card.Slot>
    </Card>
  );
};

export default InvitationListCard;
